'use client';

import { FormProvider } from '../(ui)/context/FormContext';
import { USER_TYPES } from '../(common-lib)/LoanData';
import { PreQualPageContent } from '../(ui)/ui/PreQualPageContent';

export default function Home() {
  return (
    <FormProvider userType={USER_TYPES.BORROWER}>
      <PreQualPageContent />
    </FormProvider>
  );
} 